import { useTranslation } from 'react-i18next'
import { useDeleteVoucherMutation } from '@/entities/voucher'
import { DeleteButtonWithConfirm } from '@/shared/ui/delete-button-with-confirm'

interface VoucherDeleteButtonProps {
  voucherId: string
}

export function VoucherDeleteButton({ voucherId }: VoucherDeleteButtonProps) {
  const { t } = useTranslation()
  const mutation = useDeleteVoucherMutation()

  return (
    <DeleteButtonWithConfirm
      onDelete={async () => {
        await mutation.mutateAsync(voucherId)
      }}
      isPending={mutation.isPending}
      confirmTitle={t('voucher.deleteConfirm')}
      successMessage={t('voucher.deleteSuccess')}
    />
  )
}
